import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ArrowMark from '@/components/ArrowMark'
import { PageHeaderBackdrop } from '@/components/PageHeader'
import SectionLabel from '@/components/SectionLabel'
import { SERVICES } from '@/data/services'

function ServicesHero() {
  return (
    <header style={{ paddingTop: 'var(--hdr-top)', paddingBottom: 'var(--hdr-bot)', position: 'relative', borderBottom: '1px solid var(--line-soft)', overflow: 'hidden' }}>
      <PageHeaderBackdrop variant="services" />
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="mono" style={{ display: 'flex', alignItems: 'center', gap: 12, color: 'var(--fg-3)', marginBottom: 24 }}>
          <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 3, flexShrink: 0 }}>
            <span style={{ width: 22, height: 2, background: 'var(--accent)', borderRadius: 1 }} />
            <span style={{ width: 14, height: 2, background: 'var(--accent)', opacity: 0.5, borderRadius: 1 }} />
          </span>
          <span style={{ fontSize: 13, fontWeight: 500, letterSpacing: '0.04em' }}>What we do</span>
        </div>
        <h1 className="display" style={{ fontSize: 'clamp(44px, 6.5vw, 88px)', color: 'var(--fg-0)', fontWeight: 600, letterSpacing: '-0.025em', lineHeight: 1.0, maxWidth: 1000 }}>
          Four trades. <span style={{ color: 'var(--accent)' }}>One roof.</span>
        </h1>
        <p style={{ marginTop: 28, maxWidth: 720, fontSize: 18, color: 'var(--fg-1)', lineHeight: 1.6 }}>
          We&rsquo;re unusual among Nepali contractors &mdash; civil, mechanical, electrical and sanitary work all sit inside SMT, supervised by the same project director. The cost of coordination is zero because there&rsquo;s no second contractor to coordinate with.
        </p>

        {/* Quick stats bar */}
        <div style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 0, background: '#fff', border: '1px solid var(--line-soft)', borderRadius: 16, overflow: 'hidden', maxWidth: 560 }} className="services-stats">
          {[
            { v: '4', l: 'Trade disciplines, all in-house' },
            { v: '36+', l: 'Years of operational experience' },
          ].map((s, i) => (
            <div key={i} style={{ padding: '24px 28px', borderRight: i < 1 ? '1px solid var(--line-soft)' : 'none' }}>
              <div className="display" style={{ fontSize: 32, color: 'var(--fg-0)', fontWeight: 700, letterSpacing: '-0.02em' }}>{s.v}</div>
              <div style={{ fontSize: 13, color: 'var(--fg-2)', marginTop: 4 }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 540px) {
          .services-stats { grid-template-columns: 1fr !important; }
          .services-stats > * { border-right: none !important; }
          .services-stats > :first-child { border-bottom: 1px solid var(--line-soft); }
        }
      `}</style>
    </header>
  );
}

function ServicesOverview({ active, setActive }) {
  return (
    <section style={{ padding: 'var(--sec-pad) 0', background: 'var(--bg-0)' }}>
      <div className="container">
        <SectionLabel title="Our Disciplines" count="04 trades" />
        <h2 className="display" style={{ fontSize: 'clamp(32px, 4.5vw, 56px)', marginTop: 32, color: 'var(--fg-0)', fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.05, maxWidth: 800 }}>
          Whatever you&rsquo;re building, we&rsquo;ve done it before.
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginTop: 56 }} className="svc-cards">
          {SERVICES.map((s, i) => (
            <button key={s.id} onClick={() => { setActive(i); document.getElementById('service-detail')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }} style={{
              all: 'unset', cursor: 'pointer',
              background: i === active ? 'var(--accent)' : '#fff',
              border: '1px solid', borderColor: i === active ? 'var(--accent)' : 'var(--line-soft)',
              borderRadius: 18, padding: 28,
              display: 'flex', flexDirection: 'column', gap: 16,
              transition: 'all .25s ease',
              color: i === active ? '#fff' : 'var(--fg-0)',
            }}>
              <div style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12,
                background: i === active ? 'rgba(255,255,255,0.15)' : 'var(--accent-soft)',
                color: i === active ? '#fff' : 'var(--accent-deep)',
              }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d={s.icon} />
                </svg>
              </div>
              <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', opacity: 0.65 }}>0{s.num.slice(-1)}</div>
              <h3 className="display" style={{ fontSize: 22, fontWeight: 600, letterSpacing: '-0.01em' }}>{s.title}</h3>
              <p style={{ fontSize: 13.5, lineHeight: 1.5, opacity: i === active ? 0.95 : 0.65, marginTop: 'auto' }}>{s.tagline}</p>
            </button>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 980px) { .svc-cards { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 540px) { .svc-cards { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}

function ServiceDetail({ active, setActive }) {
  const s = SERVICES[active];
  return (
    <section id="service-detail" style={{ padding: 'var(--sec-pad) 0', background: 'var(--bg-1)', borderTop: '1px solid var(--line-soft)' }}>
      <div className="container">
        <SectionLabel title={`Detail · ${s.title}`} count={`0${s.num.slice(-1)} of 04`} />
        <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 64, marginTop: 56, alignItems: 'start' }} className="svc-detail-grid">
          <div>
            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 64, height: 64, borderRadius: 16, background: 'var(--accent)', color: '#fff', marginBottom: 24 }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d={s.icon} />
              </svg>
            </div>
            <h2 className="display" style={{ fontSize: 'clamp(36px, 5vw, 64px)', color: 'var(--fg-0)', fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.05 }}>
              {s.tagline}
            </h2>
            <p style={{ marginTop: 24, fontSize: 17, color: 'var(--fg-1)', lineHeight: 1.65, maxWidth: 640 }} dangerouslySetInnerHTML={{ __html: s.desc }} />

            <div style={{ marginTop: 40 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--fg-3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 18 }}>What we deliver</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }} className="capability-grid">
                {s.capabilities.map(c => (
                  <div key={c} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', background: '#fff', padding: '14px 16px', borderRadius: 12, border: '1px solid var(--line-soft)' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18, borderRadius: 999, background: 'var(--accent-soft)', color: 'var(--accent)', flexShrink: 0, marginTop: 1 }}>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 5l2 2 4-4"/></svg>
                    </span>
                    <span style={{ fontSize: 14, color: 'var(--fg-1)', lineHeight: 1.5 }}>{c}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <aside>
            <div style={{ background: '#fff', border: '1px solid var(--line-soft)', borderRadius: 16, overflow: 'hidden' }}>
              <div style={{ background: 'var(--accent)', color: '#fff', padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Browse trades</span>
                <span style={{ fontSize: 11, opacity: 0.8 }}>0{s.num.slice(-1)} / 04</span>
              </div>
              {SERVICES.map((sv, i) => (
                <button key={sv.id} onClick={() => setActive(i)} style={{
                  all: 'unset', cursor: 'pointer', width: '100%', boxSizing: 'border-box',
                  display: 'grid', gridTemplateColumns: '36px 1fr 12px', gap: 14, padding: '16px 20px',
                  borderTop: i === 0 ? 'none' : '1px solid var(--line-soft)',
                  background: i === active ? 'var(--accent-soft)' : '#fff',
                  alignItems: 'center',
                }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, borderRadius: 10, background: i === active ? 'var(--accent)' : 'var(--bg-1)', color: i === active ? '#fff' : 'var(--fg-2)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={sv.icon} /></svg>
                  </span>
                  <span>
                    <div style={{ fontSize: 14, fontWeight: 600, color: i === active ? 'var(--accent-deep)' : 'var(--fg-0)' }}>{sv.title}</div>
                    <div style={{ fontSize: 12, color: 'var(--fg-2)', marginTop: 2 }}>{sv.tagline.replace('.', '')}</div>
                  </span>
                  <span style={{ color: i === active ? 'var(--accent)' : 'var(--fg-3)' }}>›</span>
                </button>
              ))}
            </div>

            <div style={{ background: 'var(--fg-0)', borderRadius: 16, padding: 24, marginTop: 16, color: '#fff' }}>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>Need a project that combines several of these?</div>
              <div style={{ marginTop: 8, fontFamily: 'var(--space)', fontSize: 18, fontWeight: 600, lineHeight: 1.3 }}>That&rsquo;s exactly what we do best.</div>
              <div style={{ marginTop: 16, fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.55 }}>
                Most of our work blends two or three trades. Tell us about the project and we&rsquo;ll handle the coordination internally.
              </div>
            </div>
          </aside>
        </div>
      </div>
      <style>{`
        @media (max-width: 980px) {
          .svc-detail-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
        @media (max-width: 540px) { .capability-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}

function ServicesProcess() {
  const phases = [
    { n: '01', t: 'Brief & site visit', d: 'Free initial consultation, site walk-through, and feasibility review with you and your consultant if you have one.' },
    { n: '02', t: 'Planning & mobilisation', d: 'Detailed plan, schedule, and budget. Site fencing, storage areas, temporary office and restrooms set up.' },
    { n: '03', t: 'Construction', d: 'Self-perform civil, mechanical, electrical and sanitary works with daily QA/QC and weekly progress updates.' },
    { n: '04', t: 'Handover', d: 'Formal handover with a complete project record, including drawings, manuals and warranty documents.' },
    { n: '05', t: 'Defect liability', d: '12-month defect liability period. Any genuine defects are rectified at our cost. Most projects close with zero warranty calls.' },
  ];
  return (
    <section style={{ padding: 'var(--sec-pad) 0', background: 'var(--bg-0)', borderTop: '1px solid var(--line-soft)' }}>
      <div className="container">
        <SectionLabel title="How a Project Runs" count="05 phases" />
        <h2 className="display" style={{ fontSize: 'clamp(32px, 4.5vw, 56px)', marginTop: 32, color: 'var(--fg-0)', fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.05, maxWidth: 800 }}>
          From the first phone call to your final walkthrough.
        </h2>
        <div style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 16 }} className="phases-grid">
          {phases.map((p, i) => (
            <div key={i} style={{ background: '#fff', border: '1px solid var(--line-soft)', borderRadius: 16, padding: 24, display: 'flex', flexDirection: 'column', gap: 14, position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 10, background: i === 0 ? 'var(--accent)' : 'var(--accent-soft)', color: i === 0 ? '#fff' : 'var(--accent-deep)', fontFamily: 'var(--space)', fontSize: 13, fontWeight: 700 }}>{p.n}</span>
                <span style={{ flex: 1, height: 1, background: 'var(--line-soft)' }} />
              </div>
              <h3 className="display" style={{ fontSize: 17, color: 'var(--fg-0)', fontWeight: 600, lineHeight: 1.3 }}>{p.t}</h3>
              <p style={{ fontSize: 13, color: 'var(--fg-2)', lineHeight: 1.55 }}>{p.d}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 1100px) { .phases-grid { grid-template-columns: repeat(3, 1fr) !important; } }
        @media (max-width: 720px) { .phases-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}

function ServicesCTA() {
  return (
    <section style={{ padding: 'var(--sec-pad) 0', background: 'var(--bg-0)', borderTop: '1px solid var(--line-soft)' }}>
      <div className="container">
        <div style={{
          background: 'linear-gradient(135deg, #FFFFFF 0%, #F0EBE2 100%)',
          border: '1px solid var(--line-soft)', borderRadius: 24, padding: 'clamp(40px, 6vw, 80px)',
          display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 48, alignItems: 'center',
          boxShadow: '0 30px 60px -30px rgba(0,0,0,0.10)',
        }} className="svc-cta">
          <div>
            <SectionLabel title="What's Next" />
            <h2 className="display" style={{ fontSize: 'clamp(32px, 4.5vw, 56px)', color: 'var(--fg-0)', marginTop: 24, lineHeight: 1.05, fontWeight: 600, letterSpacing: '-0.02em' }}>
              Have a project in mind? Tell us about it.
            </h2>
            <p style={{ marginTop: 20, fontSize: 16, color: 'var(--fg-1)', lineHeight: 1.6, maxWidth: 480 }}>
              Whether it&rsquo;s one trade or all four, send us a brief and we&rsquo;ll get back to you within one working day with honest feedback.
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Link to="/contact" className="btn btn-primary" style={{ justifyContent: 'space-between' }}>
              <span>Contact us</span><span className="arrow-circle"><ArrowMark /></span>
            </Link>
            <Link to="/projects" className="btn btn-ghost" style={{ justifyContent: 'space-between' }}>
              <span>See completed projects</span><span className="arrow-circle"><ArrowMark /></span>
            </Link>
          </div>
        </div>
      </div>
      <style>{`@media (max-width: 900px) { .svc-cta { grid-template-columns: 1fr !important; gap: 32px !important; } }`}</style>
    </section>
  );
}

export default function ServicesPage() {
  const [active, setActive] = useState(0);
  return (
    <div className="page">
      <ServicesHero />
      <ServicesOverview active={active} setActive={setActive} />
      <ServiceDetail active={active} setActive={setActive} />
      <ServicesProcess />
      <ServicesCTA />
    </div>
  );
}
